import { useState } from "react";

/**
 * @typedef {object} JsonModalHook
 * @property {boolean} bodyVisible - Body Modal 的可见性
 * @property {boolean} responseVisible - Response Modal 的可见性
 * @property {string} modalContent - Modal 中显示的 JSON 内容（已格式化）
 * @property {(title: string, content: string) => void} showJsonModal - 显示 JSON Modal 的函数
 * @property {() => void} hideBodyModal - 隐藏 Body Modal 的函数
 * @property {() => void} hideResponseModal - 隐藏 Response Modal 的函数
 */

/**
 * 管理 JSON Modal 显示逻辑的 Hook
 * @returns {JsonModalHook}
 */
export const useJsonModal = () => {
  const [bodyVisible, setBodyVisible] = useState(false);
  const [responseVisible, setResponseVisible] = useState(false);
  const [headerVisible, setHeaderVisible] = useState(false);
  const [modalContent, setModalContent] = useState("");

  /**
   * 显示 JSON Modal
   * @param {string} title - Modal 标题 ("Body" 或 "Response")
   * @param {string} content - 要在 Modal 中显示的原始字符串内容
   */
  const showJsonModal = (title: string, content: string) => {
    try {
      const formattedJson = JSON.stringify(JSON.parse(content), null, 2);
      setModalContent(formattedJson);
    } catch (e) {
      setModalContent(content);
    }
    if (title === "Body") {
      setBodyVisible(true);
    } else if (title === "Request Header") {
      setHeaderVisible(true);
    } else {
      setResponseVisible(true);
    }
  };

  const hideBodyModal = () => setBodyVisible(false);
  const hideResponseModal = () => setResponseVisible(false);
  const hideHeaderModal = () => setHeaderVisible(false);

  return {
    bodyVisible,
    responseVisible,
    headerVisible,
    modalContent,
    showJsonModal,
    hideBodyModal,
    hideResponseModal,
    hideHeaderModal,
  };
};
